export const REGIONS = {
  aws: [
    { id: 'us-east-1', name: 'US East (N. Virginia)' },
    { id: 'us-east-2', name: 'US East (Ohio)' },
    { id: 'us-west-1', name: 'US West (N. California)' },
    { id: 'us-west-2', name: 'US West (Oregon)' },
    { id: 'af-south-1', name: 'Africa (Cape Town)' },
    { id: 'ap-east-1', name: 'Asia Pacific (Hong Kong)' },
    { id: 'ap-south-1', name: 'Asia Pacific (Mumbai)' },
    { id: 'ap-south-2', name: 'Asia Pacific (Hyderabad)' },
    { id: 'ap-northeast-3', name: 'Asia Pacific (Osaka)' },
    { id: 'ap-northeast-2', name: 'Asia Pacific (Seoul)' },
    { id: 'ap-southeast-1', name: 'Asia Pacific (Singapore)' },
    { id: 'ap-southeast-2', name: 'Asia Pacific (Sydney)' },
    { id: 'ap-southeast-3', name: 'Asia Pacific (Jakarta)' },
    { id: 'ap-southeast-4', name: 'Asia Pacific (Melbourne)' },
    { id: 'ap-northeast-1', name: 'Asia Pacific (Tokyo)' },
    { id: 'ca-central-1', name: 'Canada (Central)' },
    { id: 'ca-west-1', name: 'Canada (Calgary)' },
    { id: 'eu-central-1', name: 'Europe (Frankfurt)' },
    { id: 'eu-central-2', name: 'Europe (Zurich)' },
    { id: 'eu-west-1', name: 'Europe (Ireland)' },
    { id: 'eu-west-2', name: 'Europe (London)' },
    { id: 'eu-south-1', name: 'Europe (Milan)' },
    { id: 'eu-south-2', name: 'Europe (Spain)' },
    { id: 'eu-west-3', name: 'Europe (Paris)' },
    { id: 'eu-north-1', name: 'Europe (Stockholm)' },
    { id: 'me-south-1', name: 'Middle East (Bahrain)' },
    { id: 'me-central-1', name: 'Middle East (UAE)' },
    { id: 'sa-east-1', name: 'South America (São Paulo)' },
  ],
  azure: [
    { id: 'eastus', name: 'US East' },
    { id: 'eastus2', name: 'US East 2' },
    { id: 'southcentralus', name: 'US South Central' },
    { id: 'westus2', name: 'US West 2' },
    { id: 'westus3', name: 'US West 3' },
    { id: 'australiaeast', name: 'Australia East' },
    { id: 'southeastasia', name: 'Asia Southeast' },
    { id: 'northeurope', name: 'Europe North' },
    { id: 'westeurope', name: 'Europe West' },
    { id: 'uksouth', name: 'UK South' },
    { id: 'ukwest', name: 'UK West' },
    { id: 'centralindia', name: 'India Central' },
    { id: 'southindia', name: 'India South' },
    { id: 'westindia', name: 'India West' },
    { id: 'eastasia', name: 'Asia East' },
    { id: 'japaneast', name: 'Japan East' },
    { id: 'japanwest', name: 'Japan West' },
    { id: 'koreacentral', name: 'Korea Central' },
    { id: 'koreasouth', name: 'Korea South' },
    { id: 'canadacentral', name: 'Canada Central' },
    { id: 'canadaeast', name: 'Canada East' },
    { id: 'francecentral', name: 'France Central' },
    { id: 'germanywestcentral', name: 'Germany West Central' },
    { id: 'norwayeast', name: 'Norway East' },
    { id: 'switzerlandnorth', name: 'Switzerland North' },
    { id: 'uaenorth', name: 'UAE North' },
    { id: 'brazilsouth', name: 'Brazil South' },
    { id: 'southafricanorth', name: 'South Africa North' },
  ],
  gcp: [
    { id: 'us-central1', name: 'US Central (Iowa)' },
    { id: 'us-east1', name: 'US East 1 (South Carolina)' },
    { id: 'us-east4', name: 'US East 4 (Northern Virginia)' },
    { id: 'us-west1', name: 'US West 1 (Oregon)' },
    { id: 'us-west2', name: 'US West 2 (Los Angeles)' },
    { id: 'us-west3', name: 'US West 3 (Salt Lake City)' },
    { id: 'us-west4', name: 'US West 4 (Las Vegas)' },
    { id: 'northamerica-northeast1', name: 'Montreal' },
    { id: 'northamerica-northeast2', name: 'Toronto' },
    { id: 'europe-west1', name: 'Europe West 1 (Belgium)' },
    { id: 'europe-west2', name: 'Europe West 2 (London)' },
    { id: 'europe-west3', name: 'Europe West 3 (Frankfurt)' },
    { id: 'europe-west4', name: 'Europe West 4 (Netherlands)' },
    { id: 'europe-west6', name: 'Europe West 6 (Zurich)' },
    { id: 'europe-west8', name: 'Europe West 8 (Milan)' },
    { id: 'europe-west9', name: 'Europe West 9 (Paris)' },
    { id: 'europe-north1', name: 'Europe North 1 (Finland)' },
    { id: 'europe-southwest1', name: 'Europe Southwest 1 (Madrid)' },
    { id: 'asia-east1', name: 'Asia East 1 (Taiwan)' },
    { id: 'asia-east2', name: 'Asia East 2 (Hong Kong)' },
    { id: 'asia-northeast1', name: 'Asia Northeast 1 (Tokyo)' },
    { id: 'asia-northeast2', name: 'Asia Northeast 2 (Osaka)' },
    { id: 'asia-northeast3', name: 'Asia Northeast 3 (Seoul)' },
    { id: 'asia-southeast1', name: 'Asia Southeast 1 (Singapore)' },
    { id: 'asia-southeast2', name: 'Asia Southeast 2 (Jakarta)' },
    { id: 'asia-south1', name: 'Asia South 1 (Mumbai)' },
    { id: 'asia-south2', name: 'Asia South 2 (Delhi)' },
    { id: 'australia-southeast1', name: 'Australia Southeast 1 (Sydney)' },
    { id: 'australia-southeast2', name: 'Australia Southeast 2 (Melbourne)' },
    { id: 'southamerica-east1', name: 'South America East 1 (Sao Paulo)' },
    { id: 'southamerica-west1', name: 'South America West 1 (Santiago)' },
    { id: 'me-west1', name: 'Middle East West 1 (Tel Aviv)' },
    { id: 'me-central1', name: 'Middle East Central 1 (Doha)' },
  ],
  oci: [
    { id: 'us-ashburn-1', name: 'US East (Ashburn)' },
    { id: 'us-phoenix-1', name: 'US West (Phoenix)' },
    { id: 'us-sanjose-1', name: 'US West (San Jose)' },
    { id: 'ca-montreal-1', name: 'Canada Southeast (Montreal)' },
    { id: 'ca-toronto-1', name: 'Canada Southeast (Toronto)' },
    { id: 'uk-london-1', name: 'UK South (London)' },
    { id: 'uk-cardiff-1', name: 'UK West (Newport)' },
    { id: 'eu-frankfurt-1', name: 'Germany Central (Frankfurt)' },
    { id: 'eu-zurich-1', name: 'Switzerland North (Zurich)' },
    { id: 'eu-amsterdam-1', name: 'Netherlands Northwest (Amsterdam)' },
    { id: 'eu-stockholm-1', name: 'Sweden Central (Stockholm)' },
    { id: 'eu-marseille-1', name: 'France South (Marseille)' },
    { id: 'eu-paris-1', name: 'France Central (Paris)' },
    { id: 'eu-milan-1', name: 'Italy Northwest (Milan)' },
    { id: 'ap-tokyo-1', name: 'Japan East (Tokyo)' },
    { id: 'ap-osaka-1', name: 'Japan Central (Osaka)' },
    { id: 'ap-seoul-1', name: 'South Korea Central (Seoul)' },
    { id: 'ap-chuncheon-1', name: 'South Korea North (Chuncheon)' },
    { id: 'ap-mumbai-1', name: 'India West (Mumbai)' },
    { id: 'ap-hyderabad-1', name: 'India South (Hyderabad)' },
    { id: 'ap-sydney-1', name: 'Australia East (Sydney)' },
    { id: 'ap-melbourne-1', name: 'Australia Southeast (Melbourne)' },
    { id: 'ap-singapore-1', name: 'Singapore (Singapore)' },
    { id: 'sa-saopaulo-1', name: 'Brazil East (Sao Paulo)' },
    { id: 'sa-vinhedo-1', name: 'Brazil Southeast (Vinhedo)' },
    { id: 'sa-santiago-1', name: 'Chile Central (Santiago)' },
    { id: 'me-jeddah-1', name: 'Saudi Arabia West (Jeddah)' },
    { id: 'me-dubai-1', name: 'UAE East (Dubai)' },
    { id: 'il-jerusalem-1', name: 'Israel Central (Jerusalem)' },
    { id: 'af-johannesburg-1', name: 'South Africa Central (Johannesburg)' },
  ],
};

export const POPULAR_MODULES = {
  aws: [
    { name: 'VPC', url: 'https://github.com/terraform-aws-modules/terraform-aws-vpc' },
    {
      name: 'EC2 Instance',
      url: 'https://github.com/terraform-aws-modules/terraform-aws-ec2-instance',
    },
    { name: 'EKS (Kubernetes)', url: 'https://github.com/terraform-aws-modules/terraform-aws-eks' },
    { name: 'S3 Bucket', url: 'https://github.com/terraform-aws-modules/terraform-aws-s3-bucket' },
    { name: 'RDS', url: 'https://github.com/terraform-aws-modules/terraform-aws-rds' },
    { name: 'Lambda', url: 'https://github.com/terraform-aws-modules/terraform-aws-lambda' },
  ],
  azure: [
    { name: 'Virtual Network', url: 'https://github.com/Azure/terraform-azurerm-vnet' },
    { name: 'AKS (Kubernetes)', url: 'https://github.com/Azure/terraform-azurerm-aks' },
    { name: 'Compute', url: 'https://github.com/Azure/terraform-azurerm-compute' },
    { name: 'Database (PostgreSQL)', url: 'https://github.com/Azure/terraform-azurerm-postgresql' },
    { name: 'Storage', url: 'https://github.com/Azure/terraform-azurerm-storage' },
  ],
  gcp: [
    {
      name: 'Network',
      url: 'https://github.com/terraform-google-modules/terraform-google-network',
    },
    {
      name: 'Kubernetes Engine',
      url: 'https://github.com/terraform-google-modules/terraform-google-kubernetes-engine',
    },
    {
      name: 'Cloud Storage',
      url: 'https://github.com/terraform-google-modules/terraform-google-cloud-storage',
    },
    {
      name: 'SQL Database',
      url: 'https://github.com/terraform-google-modules/terraform-google-sql-db',
    },
    { name: 'VM', url: 'https://github.com/terraform-google-modules/terraform-google-vm' },
  ],
  oci: [
    { name: 'VCN', url: 'https://github.com/oracle-terraform-modules/terraform-oci-vcn' },
    {
      name: 'Compute Instance',
      url: 'https://github.com/oracle-terraform-modules/terraform-oci-compute-instance',
    },
    {
      name: 'OKE (Kubernetes)',
      url: 'https://github.com/oracle-terraform-modules/terraform-oci-oke',
    },
    {
      name: 'Autonomous DB',
      url: 'https://github.com/oracle-terraform-modules/terraform-oci-autonomous-database',
    },
  ],
};

export const DEMO_MODULE_URL = 'https://github.com/terraform-aws-modules/terraform-aws-vpc';
